export function getRequestProfileWidgetColumns(widgets) {
  const columns = [[], []]

  widgets.forEach((widget, index) => {
    columns[index % columns.length].push(widget)
  })

  return columns
}
